import React, { useState } from "react";
import Layout from "../../layout/Layout";
import { Form } from "react-bootstrap";
import MyEditor from "../../components/MyEditor";
import axiosInstance from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import * as CustomToast from "../../components/CustomToastMessage";
import BlogImageUpload from "../../components/blogImageUpload";

function BlogsAdd() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    content: "",
    creditSource: "",
    // blogImage: null,
    phoneImage: null,
    notificationType: false,
    publishOn: "both",
    metaTitle: "",
    metaDescription: "",
  });
  const [loading, setLoading] = useState(false);
  const [recipeUrl, setRecipeUrl] = useState("");
  const [scraping, setScraping] = useState(false);
  const [editorKey, setEditorKey] = useState(0);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sanitizeContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
  
    // Remove unwanted elements
    doc
      .querySelectorAll(
        "img, picture, figure, svg, iframe, video, audio, script, style"
      )
      .forEach((el) => el.remove());
  
    return doc.body.innerHTML;
  };

  const handleGetData = async () => {
    const trimmed = recipeUrl?.trim();
    if (!trimmed) {
      CustomToast.error("Please enter a recipe URL");
      return;
    }

    let parsed;
    try {
      parsed = new URL(trimmed);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
        throw new Error("bad protocol");
      }
    } catch {
      CustomToast.error("Please enter a valid URL.");
      return;
    }

    setScraping(true);
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/scrape`,
        { url: parsed.toString() },
        { timeout: 60000 }
      );
      const data = response.data?.data || {};
      setFormData((prev) => ({
        ...prev,
        title: data.title || "",
        slug: data.slug || "",
        creditSource: data.creditSource || "",
        content: sanitizeContent(data.content) || "",
        metaTitle: (data.metaTitle || "").slice(0, 60),
        metaDescription: (data.metaDescription || "").slice(0, 160),
        phoneImage: data.image || null,
      }));
      setEditorKey((key) => key + 1);
      CustomToast.success(response.data?.message || "Recipe data loaded.");
    } catch (error) {
      CustomToast.error(
        error.response?.data?.message ||
          "Unable to fetch recipe. Please verify the URL."
      );
    } finally {
      setScraping(false);
    }
  };

  const handleNotificationChange = (e) => {
    setFormData({
      ...formData,
      notificationType: e.target.checked,
    });
  };
  const handlePublishChange = (e) => {
    setFormData({
      ...formData,
      publishOn: e.target.value,
    });
  };

  const handleEditorChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      content: content,
    }));
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, blogImage: file }));
  };
  const handleImagePhoneImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, phoneImage: file }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!formData?.blogImage) {
    //   CustomToast.error("Please select a recipe image for desktop");
    //   return;
    // }
    if (!formData?.phoneImage) {
      CustomToast.error("Please select a recipe image for mobile");
      return;
    }
    if (!formData?.title) {
      CustomToast.error("Please enter a recipe title");
      return;
    }
    if (!formData?.slug) {
      CustomToast.error("Please enter a recipe slug");
      return;
    }
    if (!formData?.metaTitle) {
      CustomToast.error("Please enter a meta title");
      return;
    }
    if (!formData?.metaDescription) {
      CustomToast.error("Please enter a meta description");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("slug", formData.slug);
    formDataToSend.append("content", formData.content);
    formDataToSend.append("creditSource", formData.creditSource);
    // formDataToSend.append("blogImage", formData.blogImage);
    if (formData.phoneImage instanceof File) {
      formDataToSend.append("phoneImage", formData.phoneImage);
    } else if (typeof formData.phoneImage === "string" && formData.phoneImage) {
      formDataToSend.append("phoneImageUrl", formData.phoneImage);
    }
    formDataToSend.append("notificationType", formData.notificationType);
    formDataToSend.append("publishOn", formData.publishOn);
    formDataToSend.append(
      "meta",
      JSON.stringify({
        title: formData.metaTitle,
        description: formData.metaDescription,
      })
    );

    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/create`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CustomToast.success(response.data.message);
      navigate("/blogs");
    } catch (error) {
      if (error.response?.data?.status === 400 || error.response?.data?.message) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Error sending response");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Layout title="New Recipe Blog">
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <Form.Group controlId="recipeUrl">
                  <Form.Label>Recipe URL</Form.Label>
                  <div className="d-flex gap-2 align-items-stretch">
                    <Form.Control
                      type="url"
                      name="recipeUrl"
                      value={recipeUrl}
                      onChange={(e) => setRecipeUrl(e.target.value)}
                      placeholder="https://example.com/recipe"
                      disabled={scraping || loading}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleGetData();
                        }
                      }}
                    />
                    <button
                      className="btn-primary fs-16 fw-700 px-4 d-flex align-items-center gap-2 text-nowrap"
                      type="button"
                      onClick={handleGetData}
                      disabled={scraping || loading}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      {scraping ? "Getting Data…" : "Get Data"}
                    </button>
                  </div>
                </Form.Group>
              </div>
              <div className="col-12 col-md-6">
                <Form.Group controlId="mobileImageUpload">
                  {/* <Form.Label>Recipe Image(Mobile)</Form.Label> */}
                  <Form.Label>Recipe Image</Form.Label>
                  <BlogImageUpload
                    // imageMaxHeight={250}
                    // imageMaxWidth={337}
                    imageMaxHeight={420}
                    imageMaxWidth={530}
                    onFileSelect={(file) => {
                      handleImagePhoneImageUpload(file);
                    }}
                    initialImage={formData.phoneImage}
                    name="phoneImage"
                  />
                  {/* <p className='resolution'>Note: Max file size 1mb and resolution 182x200</p> */}
                </Form.Group>
                <p className="my-1">
                  <span className="fw-semibold">Note : </span>Resolution 530x420
                  (Width x Height)
                </p>
                {/* <p className="my-1">
                  <span className="fw-semibold">Note : </span>Resolution 337x250
                  (Width x Height)
                </p> */}
              </div>
              <div className="col-12">
                <Form.Group controlId="email">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Enter recipe title"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="email">
                  <Form.Label>Slug</Form.Label>
                  <Form.Control
                    type="text"
                    name="slug"
                    value={formData.slug}
                    onChange={handleInputChange}
                    placeholder="Enter recipe slug"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="CreditSource">
                  <Form.Label>Credit Source</Form.Label>
                </Form.Group>
                <input
                  className="form-control"
                  name="creditSource"
                  value={formData.creditSource}
                  onChange={handleInputChange}
                  placeholder="Enter credit source"
                ></input>
              </div>
              <div className="col-12">
                <Form.Group controlId="Password">
                  <Form.Label>Content</Form.Label>
                </Form.Group>
                <MyEditor
                  key={editorKey}
                  htmlData={formData.content}
                  setCourseAdd={(content) => {
                    handleEditorChange(content);
                  }}
                />
              </div>
              <div className="col-3">
                <Form.Group controlId="notificationOptions">
                  <Form.Label>Publish On:</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Mobile"
                      name="publishOn"
                      type="radio"
                      id="mobile"
                      value="mobile"
                      onChange={handlePublishChange}
                      checked={formData.publishOn === "mobile"}
                    />
                    <Form.Check
                      inline
                      label="Web"
                      name="publishOn"
                      type="radio"
                      id="web"
                      value="web"
                      onChange={handlePublishChange}
                      checked={formData.publishOn === "web"}
                    />
                    <Form.Check
                      inline
                      label="Both"
                      name="publishOn"
                      type="radio"
                      id="both"
                      value="both"
                      onChange={handlePublishChange}
                      checked={formData.publishOn === "both"}
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-3">
                <Form.Group controlId="notificationOptions">
                  <Form.Label> Would you like to notify the user?</Form.Label>
                  <div>
                    <Form.Check
                      className="custom-switch d-flex align-items-center gap-2"
                      type="switch"
                      id="notification-switch"
                      label="Yes, send notification"
                      checked={formData.notificationType}
                      onChange={handleNotificationChange}
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="MetaTitle">
                  <Form.Label>Meta Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="metaTitle"
                    value={formData.metaTitle}
                    onChange={handleInputChange}
                    placeholder="Enter meta title"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="MetaDescription">
                  <Form.Label>Meta Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="metaDescription"
                    value={formData.metaDescription}
                    onChange={handleInputChange}
                    placeholder="Enter meta description"
                  />
                </Form.Group>
              </div>

              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => navigate("/blogs")}
                  type="button"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  type="button"
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default BlogsAdd;

// {false && (
//       <div className="col-12 col-md-6">
//         <Form.Group controlId="email">
//           <Form.Label>Recipe Image(Desktop)</Form.Label>
//           <BlogImageUpload
//             // imageMaxHeight={500}
//             // imageMaxWidth={455}
//             imageMaxHeight={420}
//             imageMaxWidth={530}
//             onFileSelect={(file) => {
//               handleImageUpload(file);
//             }}
//             initialImage={formData.blogImage}
//             name="blogImage"
//           />
//           {/* <p className='resolution'>Note: Max file size 1mb and resolution 182x200</p> */}
//           <p className="my-1">
//             <span className="fw-semibold">Note : </span>Resolution
//             530x420 (Width x Height)
//           </p>
//         </Form.Group>
//       </div>
//     )}
